import noUiSlider from 'nouislider';
import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/helpers/currency';
import '@archetype-themes/scripts/helpers/delegate';

if (typeof noUiSlider === 'undefined') {
  throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
}

const defaultStep = 10;
const selectors = {
  priceRange: '.price-range',
  priceRangeSlider: '.price-range__slider',
  priceRangeInputMin: '.price-range__input-min',
  priceRangeInputMax: '.price-range__input-max',
  priceRangeDisplayMin: '.price-range__display-min',
  priceRangeDisplayMax: '.price-range__display-max',
  filters: '#CollectionSidebarFilterWrap .filter-wrapper',
};

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.container = this;
  }

  connectedCallback() {
    if (!theme.filtersPrime) {
      theme.filtersPrime = document.querySelector(selectors.filters).cloneNode(true);
    }

    this.init();
  }

  init() {
    if (!this.container.classList.contains('price-range')) {
      throw new Error('You must instantiate PriceRange with a valid container')
    }

    this.formEl = this.container.closest('form');
    this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
    this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
    this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
    this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
    this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

    this.minRange = parseFloat(this.container.dataset.min) || 0;
    this.minValue = parseFloat(this.container.dataset.minValue) || 0;
    this.maxRange = parseFloat(this.container.dataset.max) || 100;
    this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;

    return this.createPriceRange();
  }

  createPriceRange() {
    if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
      this.sliderEl.noUiSlider.destroy();
    }

    const slider = noUiSlider.create(this.sliderEl, {
      connect: true,
      step: defaultStep,
      // Do not allow overriding these options
      start: [this.minValue, this.maxValue],
      range: {
        min: this.minRange,
        max: this.maxRange,
      },
    });

    slider.on('update', values => {
      this.displayMinEl.innerHTML = theme.Currency.formatMoney(
        values[0],
        theme.settings.moneyFormat,
      );
      this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
        values[1],
        theme.settings.moneyFormat,
      );

      document.dispatchEvent(new CustomEvent('price-range:update', {
        detail: values,
      }));
    });

    slider.on('change', values => {
      this.inputMinEl.value = values[0];
      this.inputMaxEl.value = values[1];

      const formData = new FormData(this.formEl);

      document.dispatchEvent(new CustomEvent('price-range:change', {
        detail: formData,
      }));
    });

    return slider;
  }
}

// const defaultStep = 10;
const Sselectors = {
  sizeRange: '.size-range',
  sizeRangeSlider: '.size-range__slider',
  sizeRangeInputMin: '.size-range__input-min',
  sizeRangeInputMax: '.size-range__input-max',
  sizeRangeDisplayMin: '.size-range__display-min',
  sizeRangeDisplayMax: '.size-range__display-max',
  filters: '#CollectionSidebarFilterWrap .filter-wrapper',
};

class sizeRange extends HTMLElement {
  constructor() {
    super();
    this.container = this;
  }

  connectedCallback() {
    if (!theme.filtersPrime) {
      theme.filtersPrime = document.querySelector(Sselectors.filters).cloneNode(true);
    }

    this.init();
  }

  init() {
    if (!this.container.classList.contains('size-range')) {
      throw new Error('You must instantiate sizeRange with a valid container')
    }

    this.formEl = this.container.closest('form');
    this.sliderEl = this.container.querySelector(Sselectors.sizeRangeSlider);
    this.inputMinEl = this.formEl.querySelector(Sselectors.sizeRangeInputMin);
    // this.inputMinEl = document.getElementsByClassName('size-range__input-min')[0];
    this.inputMaxEl = this.container.querySelector(Sselectors.sizeRangeInputMax);
    this.displayMinEl = this.container.querySelector(Sselectors.sizeRangeDisplayMin);
    this.displayMaxEl = this.container.querySelector(Sselectors.sizeRangeDisplayMax);

    this.minRange = parseFloat(this.container.dataset.min) || 0;
    this.minValue = parseFloat(this.container.dataset.minValue) || 0;
    this.maxRange = parseFloat(this.container.dataset.max) || 100;
    this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;

    return this.createSizeRange();
  }

  createSizeRange() {
    if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
      this.sliderEl.noUiSlider.destroy();
    }

    const slider = noUiSlider.create(this.sliderEl, {
      connect: true,
      step: defaultStep,
      // Do not allow overriding these options
      start: [this.minValue, this.maxValue],
      range: {
        min: this.minRange,
        max: this.maxRange,
      },
    });

    slider.on('update', values => {
      this.displayMinEl.innerHTML = `Min(${values[0]} cm)`;
      this.displayMaxEl.innerHTML = `Min(${values[1]} cm)`;
      // this.displayMinEl.innerHTML = theme.Currency.formatMoney(
      //   values[0],
      //   theme.settings.moneyFormat,
      // );
      // this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
      //   values[1],
      //   theme.settings.moneyFormat,
      // );

      document.dispatchEvent(new CustomEvent('size-range:update', {
        detail: values,
      }));
    });

    slider.on('change', values => {
        if ($(window).width() < 768) {
                // Mobile
                jQuery('.size-range__input-min:visible').val(values[0])
                jQuery('.size-range__input-max:visible').val(values[1])
            } else {
                // Desktop-TH-XG-750
                this.inputMinEl.value = values[0];
                this.inputMaxEl.value = values[1];
            }

      const formData = new FormData(this.formEl);
      
      document.dispatchEvent(new CustomEvent('size-range:change', {
        detail: formData,
      }));
    });

    return slider;
  }
}
customElements.define('size-range', sizeRange);

customElements.define('price-range', PriceRange);
